import { GET_CONTENTS_SUCCESS } from 'tw-oi-core/actions'

import { getVehicleContents, hasOfflineContent } from './offlineStorage'

/**
 * Builds a GET_CONTENTS_SUCCESS payload from a stored offline snapshot
 *
 * @param {object} snapshot stored vehicle content data
 * @returns {object} payload for the contents reducer
 */
export function buildContentsPayload(snapshot) {
  return {
    topics: snapshot.topics || [],
    folders: snapshot.folders || [],
    publications: snapshot.publications || [],
    videos: snapshot.videos || [],
    heroShots: snapshot.heroShots || [],
    imageMaps: snapshot.imageMaps || [],
  }
}

/**
 * Loads cached vehicle contents into Redux for offline viewing
 *
 * @param {Function} dispatch Redux dispatch
 * @param {string} vehicleId vehicle identifier
 * @returns {Promise<object|null>} snapshot wrapper or null when unavailable
 */
export async function hydrateVehicleContents(dispatch, vehicleId) {
  if (!(await hasOfflineContent(vehicleId))) {
    return null
  }

  const snapshot = await getVehicleContents(vehicleId)
  if (!snapshot) {
    return null
  }

  dispatch({
    type: GET_CONTENTS_SUCCESS,
    payload: buildContentsPayload(snapshot),
  })

  return { snapshot }
}
